import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=0aa6df16&scoped=true&"
import script from "./CommonList.vue?vue&type=script&lang=js&"
export * from "./CommonList.vue?vue&type=script&lang=js&"
import style0 from "./CommonList.vue?vue&type=style&index=0&id=0aa6df16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6df16",
  null
  
)

export default component.exports